module.exports = __webpack_public_path__ + "static/media/ResetPassword.cf327758.png";